import api from "api";

const getUser = () =>
  api.get("/account/getUserData")

export default { getUser }